import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, CircularProgress } from '@mui/material';
export var BasicLoader = function () { return (_jsx("div", { style: { padding: 20, textAlign: 'center' }, children: _jsx(Typography, { children: "Loading..." }) })); };
export var AnimatedLoader = BasicLoader;
export var AnimatedLoaderWithText = function (_a) {
    var text = _a.text;
    return (_jsx("div", { style: { padding: 20, textAlign: 'center' }, children: _jsx(Typography, { children: text !== null && text !== void 0 ? text : 'Loading...' }) }));
};
export var WheelOfProgress = function (_a) {
    var msg = _a.msg, _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.thickness, thickness = _c === void 0 ? 6 : _c;
    return (_jsxs("div", { style: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
        }, children: [_jsx(CircularProgress, { size: size, thickness: thickness }), msg && (_jsx(Typography, { variant: "body2", style: {
                    marginLeft: 8,
                }, children: msg }))] }));
};
